<template>
  <div class="bg-light input_card" :class="className">
    <h3 class="input_label my_0">{{ label }}</h3>
    <p class="paragraph my_0">{{ description }}</p>
    <slot></slot>
    <p class="font_regular text_12 text_black_secondary my_0">{{ help_text }}</p>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: false
    },
    description: {
      type: String,
      required: false
    },
    help_text: {
      type: String,
      required: false
    },
    className: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';
.input_card{
  padding: 8px 12px;
  border-radius: 8px;
//   border: 1px solid #E0E0E0;
}

</style>